import { useState } from "react";
import { upload } from "../../services/upload";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { LucideUpload } from "lucide-react";

interface Props {
  onUpload(urls: string[]): void;
  onError?(error: any): void;
  onStartLoading?(): void;
  onEndLoading?(): void;
  onChange?(): void;

  accept?: string; // "image/png, image/jpeg"
  type?: string;
  text?: string;
  multiple?: boolean;

  small?: boolean;
  light?: boolean;
  disabled?: boolean;
  loading?: boolean;
}

export default function Upload(props: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const [, setLenght] = useState(0);
  const [_id] = useState("upload_" + Math.random());

  const { t } = useTranslation();

  const uploadInput = async (e: any) => {
    props.onChange?.();

    setIsLoading(true);
    props.onStartLoading?.();

    try {
      const files = Array.from(e.target.files);

      setLenght(files.length);

      const toUpload = [];
      for (let i = 0; i < files.length; i++) {
        const element = files[i] as any;

        const readAsync = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(element);

          reader.onloadend = async () => {
            if (reader.result) resolve(reader.result);
          };
        });

        toUpload.push(readAsync);
      }

      const urls = await upload(toUpload);

      props.onUpload(urls);
    } catch (error) {
      props.onError?.(error);
    }

    setIsLoading(false);
    props.onEndLoading?.();
  };

  return (
    <>
      <input
        id={_id}
        type={props.type ?? "file"}
        accept={props.accept}
        multiple={props.multiple}
        hidden
        disabled={isLoading}
        onChange={uploadInput}
      />

      <Button
        type="button"
        variant={"gray"}
        size={props.small ? "sm" : "lg"}
        onClick={() => {
          document.getElementById(_id)?.click();
        }}
      >
        <LucideUpload className="me-1" size={16} /> {t("buttons.upload")}
      </Button>
    </>
  );
}
